export default "__VITE_ASSET__9b5f0b0a__"